import { Store } from "react-notifications-component";
import { Image } from "../../nav";
import { Spacer } from "../spacer";
import { TwoTextContainer, TwoTextContent, TwoTextLines, TwoTextTitle, TwoTextTitleWithEdit } from "./styles";
import { CopyToClipboard } from "react-copy-to-clipboard";

export const TwoText = ({
  topText,
  bottomText,
  icon,
  isCurrency,
  editIcon,
  onEditIconClick,
  copyValue,
}: {
  topText: string;
  bottomText: string;
  icon: string;
  isCurrency: boolean;
  editIcon?: string;
  onEditIconClick?: () => void;
  copyValue?: string;
}) => {

  const onCopyToClipboard = () => {
    Store.addNotification({
      insert: "top",
      container: "top-right",
      message: "Copied to clipboard",
      type: "success",
      dismiss: {
        duration: 2000,
      },
    });
  };



  return (
    <TwoTextContainer>
      {editIcon && onEditIconClick ? (
        <TwoTextTitleWithEdit>
          <TwoTextTitle>{topText}</TwoTextTitle>
          <div onClick={onEditIconClick} style={{ cursor: "pointer", display: "flex", alignItems: "center" }}>
            <Image src={editIcon} alt="edit-icon" style={{ width: "18px", height: "18px", cursor: "pointer" }} />
          </div>
        </TwoTextTitleWithEdit>
      ) : (
        <TwoTextTitle>{topText}</TwoTextTitle>
      )}
      <Spacer height={10} />
      <TwoTextContent>
        <TwoTextLines>
          {isCurrency ? (
            <>NGN {Number(bottomText).toLocaleString("en-US")}</>
          ) : (
            bottomText.split("\n").map((line, index) => (
              <span key={`${line}-${index}`}>{line}</span>
            ))
          )}
        </TwoTextLines>
        {icon && (
          <>
            <CopyToClipboard text={copyValue ?? bottomText} onCopy={onCopyToClipboard}>
              <Image
                style={{ cursor: "pointer" }}
                src={icon}
              />
            </CopyToClipboard>
          </>
        )}{" "}
      </TwoTextContent>
    </TwoTextContainer>
  );
};
